// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3m2-3","content":"LayoutSettings_content__20UoW"};